import { Pipe, PipeTransform } from '@angular/core';

import { MenuPermissionViewModel, Permission } from '@models/permission';

type PermissionArgs = {
  permission?: Permission;
  permissions?: Permission[];
  operator?: 'AND' | 'OR';
};

/**
 * Pipe that checks if a given permission exists within a list of module permissions.
 * @name cipoHasPermission
 * @example
 * .@if (modulePermissions | cipoHasPermission: { permission: Permission.Read }) {
 *  <p>You have read permission</p>
 * }
 *
 * .@if (modulePermissions | cipoHasPermission: { permissions: [Permission.Read, Permission.Write], operator: 'AND' }) {
 *  <p>You have read and write permissions</p>
 * }
 *
 * .@if (modulePermissions | cipoHasPermission: { permissions: [Permission.Read, Permission.Write], operator: 'OR' }) {
 * <p>You have read or write permissions</p>
 * }
 *
 */
@Pipe({
  name: 'cipoHasPermission',
})
export class HasPermissionPipe implements PipeTransform {
  transform(value: MenuPermissionViewModel[], args: PermissionArgs): boolean {
    const { permission, permissions, operator } = args;
    if (!value?.length || !(permission || permissions)) {
      return false;
    }
    if (permissions) {
      return operator === 'AND'
        ? permissions.every(x => value.some(y => y.id === x))
        : permissions.some(x => value.some(y => y.id === x));
    }
    return value.some(x => x.id === permission);
  }
}
